<template>
  <div class="row">
    <TextField
      class="small-6 medium-6 large-6 signature"
      v-if="isEditing"
      :label="label"
      :value="content"
      :showColon="false"
      :readonly="!isEditing"
      :required="isEditing"
      defaultEmpty
      @updateValue="updateContent"
    />

    <div class="small-6 medium-6 large-6 preview">
      <label class="title">{{ label }} {{ isEditing ? $t('action.preview') : '' }}</label>
      <div
        class="clearfix content"
        :key="previewKey || new Date().getTime()"
        v-html="content"
      />
    </div>
  </div>
</template>

<script>
import TextField from '@/controls/TextField'

export default {
  props: {
    label: String,
    previewKey: String,
    isEditing: Boolean,
    content: String,
    updateContent: {
      type: Function,
      default: () => {},
    },
  },
  components: {
    TextField,
  },
}
</script>

<style lang="scss" scoped>
.signature .text-input textarea {
  min-height: 60px;
  overflow-y: auto;
  max-height: 250px;
}
.preview {
  label {
    margin-top: 5px;
    margin-bottom: 3px;
    font-weight: bold;
  }
  .content {
    border: dotted 1px #B5B5B5;
    min-height: 60px;
    display: flex;
    flex-direction: column;
    label {
      margin-top: 0;
      margin-bottom: 0;
    }
  }
}
</style>
